"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var react_redux_1 = require("react-redux");
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var TenantSwitcher = function () {
    var _a;
    var currentTenant = react_redux_1.useSelector(function (state) { return state.tenant; });
    var changeTenant = function (e) {
        UserManager_1.default.signinRedirect({
            extraQueryParams: {
                tenant: e.key,
            },
        });
    };
    var menu = (react_1.default.createElement(antd_1.Menu, { selectable: false, onClick: changeTenant }, currentTenant.available.map(function (availableTenant, i) { return (react_1.default.createElement(antd_1.Menu.Item, { key: availableTenant === null || availableTenant === void 0 ? void 0 : availableTenant.id }, availableTenant === null || availableTenant === void 0 ? void 0 : availableTenant.name)); })));
    return (react_1.default.createElement(antd_1.Dropdown, { overlay: menu, placement: "bottomRight", trigger: ['click'] },
        react_1.default.createElement("a", { className: "ant-dropdown-link", onClick: function (e) { return e.preventDefault(); }, role: "button", tabIndex: 0, "aria-hidden": "true" }, (_a = currentTenant.current) === null || _a === void 0 ? void 0 :
            _a.name,
            " ",
            react_1.default.createElement(icons_1.DownOutlined, null))));
};
exports.default = TenantSwitcher;
//# sourceMappingURL=index.js.map